module.exports = __webpack_public_path__ + "static/media/img3.c2875418.jpg";